import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser, logout } from "../redux/reducers/userSlice";


const withAuthChecker = (Component, intervalMinutes = 5) => {
    return function WrappedComponent(props) {
        const dispatch = useDispatch();

        useEffect(() => {
            validateToken();

            const intervalMs = intervalMinutes * 60 * 1000;
            const intervalId = setInterval(validateToken, intervalMs);

            return () => clearInterval(intervalId);
        }, [dispatch]);

        const validateToken = () => {
            const access = localStorage.getItem("access_token");
            if (!access) {
                // No token stored, logout if user is in redux
                dispatch(logout());
                return;
            }

            fetch("/api/auth/login", {
                method: "POST",
                headers: { "Content-Type": "text/plain" },
                body: JSON.stringify({ access_token: access }),
            })
                .then(async (res) => {
                    if (!res.ok) {
                        // Invalid response, logout
                        dispatch(logout());
                        return;
                    }
                    const data = await res.json().catch(() => null);
                    if (data) {
                        // Valid token, update user
                        dispatch(setUser(data));
                    } else {
                        // No user data returned, logout
                        dispatch(logout());
                    }
                })
                .catch(() => {
                    // Network error or other failure, logout
                    dispatch(logout());
                });
        };

        return <Component {...props} />;
    };
};

export default withAuthChecker;



